import { __extends, __rest, __assign } from 'tslib';
import React__default from 'react';
import 'react-dates/initialize';
import clsx from 'clsx';
import { DayPickerRangeController } from 'react-dates';
import moment from 'moment';
import Text from '../Text/Text.component.js';
import { Button } from '../Button/Button.component.js';
import { Icon } from '../Icon/Icon.component.js';
import colors from '../../util/colors.js';
import { propTypes, defaultProps } from './DateRangePickerInline.types.js';
import './DateRangePickerInline.scss.js';
import styles from './DateRangePickerInline.module.scss.js';

var DateRangePickerInline = /** @class */ (function (_super) {
    __extends(DateRangePickerInline, _super);
    function DateRangePickerInline() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            focusedInput: _this.props.isStartDateInitiallyFocused
                ? 'startDate'
                : null,
        };
        _this.handleOnFocusChange = function (focusedInput) {
            var isStartDateInitiallyFocused = _this.props.isStartDateInitiallyFocused;
            // if isStartDateInitiallyFocused not clear focusedInput to keep Controllers always open
            if (focusedInput || !isStartDateInitiallyFocused) {
                _this.setState({ focusedInput: focusedInput });
            }
        };
        _this.renderDayContents = function (day) {
            var _a = _this.props, startDate = _a.startDate, endDate = _a.endDate, _b = _a.firstDayOfWeek, firstDayOfWeek = _b === void 0 ? 0 : _b;
            day.locale(_this.props.calendarLocale || 'en-US');
            var compareDay = function (date) {
                return date.format('MM/DD/YYYY') === day.format('MM/DD/YYYY');
            };
            var lastDayOfWeek = firstDayOfWeek ? firstDayOfWeek - 1 : 6;
            var isFirstDateOfWeek = day.day() === firstDayOfWeek;
            var isLastDateOfWeek = day.day() === lastDayOfWeek;
            var isFirstDayOfMonth = day.date() === 1;
            var isLastDayOfMonth = day.date() === day.daysInMonth();
            var isFirstDayOfLine = isFirstDateOfWeek || isFirstDayOfMonth;
            var isLastDayOfLine = isLastDateOfWeek || isLastDayOfMonth;
            var isStartDate = isFirstDayOfLine || (startDate && compareDay(startDate));
            var isEndDate = isLastDayOfLine || (endDate && compareDay(endDate));
            var isLonelyStartDay = isStartDate && isLastDayOfLine;
            var isLonelyEndDay = isEndDate && isFirstDayOfLine;
            var isLonelyDate = isLonelyStartDay ||
                isLonelyEndDay ||
                (isStartDate && (!endDate || isEndDate));
            var dayClass = clsx('SingleDate', isStartDate && !isLonelyDate && 'SingleDate___selectedStartDate', isEndDate && !isLonelyDate && 'SingleDate___selectedEndDate', isLonelyDate && 'SingleDate___selectedLonelyDate');
            return (React__default.createElement("div", { className: dayClass },
                React__default.createElement("span", { className: "SingleDate_date" }, day.format('D'))));
        };
        _this.renderMonthElement = function (_a) {
            var month = _a.month;
            month.locale(_this.props.calendarLocale || 'en-US');
            return React__default.createElement(Text, { type: "sub1" }, month.format('MMMM YYYY'));
        };
        return _this;
    }
    DateRangePickerInline.prototype.handleFirstButtonClick = function (focusedInput) {
        // Collapse on second click
        if (focusedInput === this.state.focusedInput) {
            this.setState({ focusedInput: null });
        }
        else {
            this.setState({ focusedInput: focusedInput });
        }
    };
    DateRangePickerInline.prototype.renderButton = function (input, isFirst) {
        var _this = this;
        var focusedInput = this.state.focusedInput;
        var _a = this.props, startDate = _a.startDate, endDate = _a.endDate, startDateLabel = _a.startDateLabel, endDateLabel = _a.endDateLabel;
        var date = input === 'startDate' ? startDate : endDate;
        var title = date ? moment(date).format('MM/DD/YYYY') : 'MM/DD/YYYY';
        var showLabels = startDateLabel || endDateLabel;
        return (React__default.createElement("div", { className: clsx(styles.ButtonWrapper, isFirst && styles.ButtonWrapper___first) },
            showLabels && (React__default.createElement("div", { className: styles.ButtonWrapper_label }, input === 'startDate' ? startDateLabel : endDateLabel)),
            React__default.createElement(Button, { variant: "tertiary", "aria-label": input === 'startDate' ? startDateLabel : endDateLabel, onClick: function () { return _this.handleFirstButtonClick(input); }, className: clsx(styles.Button, isFirst && styles.Button___first, focusedInput === input && styles.Button___active), "data-testid": "custom-".concat(input.replace('D', '-d'), "-button"), type: "button" },
                React__default.createElement(React__default.Fragment, null,
                    React__default.createElement("div", { className: styles.Text }, title),
                    React__default.createElement(Icon, { name: focusedInput === input
                            ? 'ChevronUpIcon'
                            : 'ChevronDownIcon', alt: "Arrow", size: 24, className: styles.Icon, color: focusedInput === input
                            ? colors.primary50
                            : colors.black })))));
    };
    DateRangePickerInline.prototype.render = function () {
        var focusedInput = this.state.focusedInput;
        var _a = this.props, renderDayContents = _a.renderDayContents, omittedCalendarProps = __rest(_a, ["renderDayContents"]);
        // We need to pass all the other props to the inner calendar
        var calendarProps = __assign({}, omittedCalendarProps);
        delete calendarProps.calendarLocale;
        delete calendarProps.startDateLabel;
        delete calendarProps.endDateLabel;
        delete calendarProps.isStartDateInitiallyFocused;
        return (React__default.createElement("div", { className: styles.DateRangePickerInline },
            React__default.createElement("div", { className: styles.DateRangePickerInline_content },
                this.renderButton('startDate', true),
                this.renderButton('endDate', false)),
            focusedInput && (React__default.createElement("div", { className: "DateRangePickerInline" },
                React__default.createElement(DayPickerRangeController, __assign({ focusedInput: focusedInput, onFocusChange: this.handleOnFocusChange, noBorder: true, navPrev: React__default.createElement("div", { className: styles.DateRangePickerInlineArrow, tabIndex: 0, "aria-label": "Move to previous month" },
                        React__default.createElement(Icon, { name: "ChevronLeftIcon", alt: "Previous Month", size: 24, className: styles.DateRangePickerInlineArrow_arrow })), navNext: React__default.createElement("div", { className: styles.DateRangePickerInlineArrow, tabIndex: 0, "aria-label": "Move to next month" },
                        React__default.createElement(Icon, { name: "ChevronRightIcon", alt: "Next Month", size: 24, className: styles.DateRangePickerInlineArrow_arrow })), numberOfMonths: 1, renderDayContents: renderDayContents || this.renderDayContents, renderMonthElement: this.renderMonthElement, hideKeyboardShortcutsPanel: true, initialVisibleMonth: null }, calendarProps, { 
                    // We can't let the user override this prop because it is mutually exclusive with renderMonthElement
                    renderMonthText: undefined }))))));
    };
    DateRangePickerInline.displayName = 'DateRangePickerInline';
    DateRangePickerInline.propTypes = propTypes;
    DateRangePickerInline.defaultProps = __assign({}, defaultProps);
    return DateRangePickerInline;
}(React__default.Component));

export { DateRangePickerInline as default };
